import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { ErrorInterceptor } from './core/interceptors/error.interceptor';
import { JwtTokenInterceptor } from './core/interceptors/jwt-token.interceptor';
import { ErrorHandler } from '@angular/core';
import * as Sentry from '@sentry/angular';
import { TimezonePipe } from '@pipes/timezone.pipe';

export const CUSTOM_PROVIDERS = [
  // if convert any Class based interceptor to the Function based then insated of useClass use useValue or register directory on withInterceptor array
  { provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true },
  { provide: HTTP_INTERCEPTORS, useClass: JwtTokenInterceptor, multi: true },
  {
    provide: ErrorHandler,
    useValue: Sentry.createErrorHandler({
      showDialog: false,
      logErrors: true,
    }),
  },
  TimezonePipe,
];
